import React, { Component } from 'react';

import './Textarea.css';

class Textarea extends Component {

  constructor(props){
    super(props);

    this.value = (this.props.value) ? this.props.value : "";
    this.type = (this.props.type) ? this.props.type : 'text';
    this.checked = (this.props.checked) ? this.props.checked : false;

    if( this.type === "submit"){
      this.value = this.props.label;
    }

    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(props, state){
    this.value = (props.value) ? props.value : "";

    if( this.type === "submit"){
      this.value = props.label;
    }
  }
  handleChange(e){
    const target = e.target;
    var val = target.value;

    let prop = (this.props.id)? this.props.id : target;
    console.log('change text: ', prop, val);
    this.props.onChange(prop, val);
  }

  render() {

    return (
      <div className="input-wrapper">
        <label className={(this.props.noLabel) ? 'hidden' : ''} htmlFor={'input-' + (this.props.id)}>{this.props.label}</label>

        <textarea name={'input-' + (this.props.id)}
          placeholder={this.props.label}
          onChange={this.handleChange}
          value={this.value}
          >
        </textarea>
      </div>
    );
  }
}

export default Textarea;

// <div className="input-wrapper">
//   <label for={ 'input-' + (this.props.id)}>{this.props.label}</label>
//   <input type="text" name={'input-' + (this.props.id)} placeholder={this.props.label} value={this.props.value} onChange={this.handleChange} />
// </div>

// EditArea.propTypes = {
//   text: React.PropTypes.string.isRequired
// }
